import React from "react";
import { observer } from "mobx-react";
import { UserWidgetConfigViewStore } from "../../store";
import { UserWidgetConfigViewForm } from "./UserWidgetConfigViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type UserWidgetConfigViewProps = {
  userWidgetConfigViewStore: UserWidgetConfigViewStore;
};

export const UserWidgetConfigView: React.FC<UserWidgetConfigViewProps> =
  observer(({ userWidgetConfigViewStore }) => {
    return (
      <div>
        <UserWidgetConfigViewForm
          userValue={userWidgetConfigViewStore.userValue}
          widgetValue={userWidgetConfigViewStore.widgetValue}
          enabled={userWidgetConfigViewStore.enabledValue}
          position={userWidgetConfigViewStore.positionValue}
          configOverride={userWidgetConfigViewStore.configOverrideValue}
          displayOrder={userWidgetConfigViewStore.displayOrderValue}
          onPrint={(handlePrint: () => void) =>
            userWidgetConfigViewStore.printUserWidgetConfig(handlePrint)
          }
          onCancel={() => userWidgetConfigViewStore.cancelUserWidgetConfig()}
          onEdit={
            userWidgetConfigViewStore.isEditEnabled
              ? () => userWidgetConfigViewStore.editUserWidgetConfig()
              : undefined
          }
        />
        <ErrorDialog
          open={userWidgetConfigViewStore.errorDialogOpened}
          title={userWidgetConfigViewStore.errorTitle}
          description={userWidgetConfigViewStore.errorDescription}
          onClose={() => userWidgetConfigViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
